export const SingleUseColumnsDisplayNames: string[] = [
  'Parent object',
  'Parent manage package',
  'Node assignee',
  'Optimization status',
  'Tags'
];

export const SingleUseSnakeCaseColumns: string[] = [
  'parent_object',
  'parent_manage_package',
  'node_assignee',
  'optimization_status',
  'tags'
];
